import Swal from "sweetalert2";
import { SessionExpiredError } from '../../common/erros/SessionExpiredError';
import { handleLogout } from './handleLogout';
import { applog } from '../../domain/utils/applog';

export const handleError = (error: Error) => {

    applog('handleError',"APP ERROR", error);

    if (error instanceof SessionExpiredError) {
        Swal.fire(
            "Error",
            "La sesión ya expiró, vuelve a iniciar sesión para continuar",
            'error'
        ).then((_) => {
            handleLogout();
        })
    } else {
        Swal.fire(
            "Error",
            error.message,
            'error'
        );
    }

}
